<template>
  <a class="water-index" href="/finish-su-endeksi/" target="_blank">
    <div class="water-index__logo">
      <img src="@/assets/img/link_img/fse-ticker-logo@3x.png">
    </div>
    <div class="water-index__sum">
      <img src="@/assets/img/icons/oval@3x.png">
      <div class="water-index__sum-text">{{ fseValue }}</div>
    </div>
  </a>
</template>

<script>
import axios from "axios";

export default {
  name: "WaterIndex",
  data() {
    return {
      fseValue: ''
    }
  },
  mounted() {
    axios({
      url: 'https://finishtasarrufsozu.com/get_data',
      method: 'get'
    }).then(response => {
      let targetArr = response.data.data.fse;
      this.fseValue = targetArr[targetArr.length - 1].toFixed(2);
    }).catch(error => {
      console.error(error);
    })
  }
}
</script>

<style lang="scss">
.water-index {
  width: 175px;
  height: 54px;
  padding: 7px 0 7px 10px;
  position: absolute;
  top: 115px;
  right: 0;
  border-radius: 15px 0 0 15px;
  background-color: #e4e4e4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 20;
  cursor: pointer;
  text-decoration: none;

  &__logo {
    width: 70px;
    margin-right: 5px;

    img {
      height: 43px;
      display: block;
      object-fit: contain;
      width: 100%;
    }
  }

  &__sum {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 81px;
    height: 42px;
    border-radius: 10px 0 0 10px;
    background-color: #ffffff;

    img {
      width: 14px;
      height: 20px;
      object-fit: contain;
    }

    &-text {
      font-family: "Rajdhani", sans-serif, Tahoma;
      font-size: 25px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #484848;
      height: auto;
      transform: translateY(2px);
      display: flex;
      align-items: center;
    }
  }

  @media only screen and (max-device-width: 768px) {
    width: 270px;
    height: 94px;
    top: 145px;

    &__logo {
      width: 110px;
      margin-right: 5px;

      img {
        height: 100%;
      }
    }

    &__sum {
      width: 121px;
      height: 62px;

      img {
        width: 24px;
        height: auto;
      }

      &-text {
        font-size: 37px;
      }
    }
  }
}
</style>
